export const CREDIT_SCORE_DECEASED = 1;
export const CREDIT_SCORE_LACK_OF_INFORMATION = 4;
export const CREDIT_SCORE_TOO_MANY_RECORDS = 9000;

export const CREDIT_SCORE_EXCLUSION_CODES = [
  CREDIT_SCORE_DECEASED,
  CREDIT_SCORE_LACK_OF_INFORMATION,
  CREDIT_SCORE_TOO_MANY_RECORDS,
];

export const POSITIVE_VANTAGE_SCORE_MAP = {
  P04: 'The balances on your accounts are not too high compared to loan limits.',
  P05: 'There are no or only a few recent delinquencies on your accounts.',
  P06: 'You have few or no accounts that were opened recently.',
  P07: 'You have either no or few delinquent or derogatory accounts.',
  P08: 'One or more of your accounts were paid on time in recent months.',
  P09: 'None of your accounts have a severe delinquency or a derogatory status.',
  P10: 'One or more of your accounts have been paid on time.',
  P11: 'You have few or no accounts with delinquent or derogatory balances.',
  P12: 'The date that you opened your oldest account is not too recent.',
  P13: 'Your most recently opened account is not too new.',
  P14: 'Your credit file contains enough information about your use of credit.',
  P15: 'None of your accounts have a recent delinquency or a derogatory status.',
  P16: 'The total of all balances on your open accounts is not too high.',
  P17: 'Balances on prior delinquent accounts not too high compared to loan amounts.',
  P18: 'Total of balances on accounts never late not too high compared to loan amounts.',
  P21: 'No open accounts in your credit file.',
  P22: 'No recently reported account information.',
  P23: 'Lack of sufficient relevant account information.',
  P29: 'Few or none of your open bankcard or revolving accounts has a balance.',
  P30: 'One or more of your bankcard or revolving accounts has a high limit.',
  P31: 'Few or none of your bankcard or revolving accounts was opened recently.',
  P32: 'Balances on bankcard or revolving accounts not too high compared to limits.',
  P33: 'No severe delinquency/derogatory status on bankcard or revolving accounts.',
  P34: 'Total of all balances on bankcard or revolving accounts is not too high.',
  P35: 'Your highest bankcard or revolving account balance is not too high.',
  P36: 'Largest credit limit on open bankcard or revolving accounts is not too low.',
  P39: 'Available credit on open bankcard or revolving accounts is not too low.',
  P40: 'Date your oldest bankcard or revolving account opened is not too recent.',
  P42: 'Date your newest bankcard or revolving account opened is not too recent.',
  P43: 'Credit file has enough history on your use of bankcard/revolving accounts.',
  P44: 'Few or no bankcard or revolving accounts with delinquent/derogatory status.',
  P45: 'Few or no bankcard/revolving accounts with delinquent /derogatory balances.',
  P47: 'No open bankcard or revolving accounts in your credit file.',
  P48: 'No bankcard or revolving recently reported account information.',
  P49: 'Lack of sufficient relevant bankcard or revolving account information.',
  P50: 'No open retail revolving accounts in your credit file.',
  P52: 'No open home equity loans in your credit file.',
  P53: 'No real estate accounts with severe delinquency or derogatory status.',
  P54: 'Amount of balance paid down on open real estate accounts is not too low.',
  P55: 'Open real estate account balances not too high compared to loan amounts.',
  P57: 'Few or no real estate accounts with delinquent or derogatory payment status.',
  P58: 'The total of all balances on open real estate accounts is not too high.',
  P61: 'No open real estate accounts in your credit file.',
  P62: 'No recently reported real estate account information.',
  P63: 'Lack of sufficient relevant real estate account information.',
  P64: 'No open first mortgage accounts in your credit file.',
  P65: 'Lack of sufficient relevant first mortgage account information.',
  P66: 'Balances on open auto accounts are not too high compared to loan amounts.',
  P68: 'No open auto accounts in your credit file.',
  P69: 'Lack of sufficient relevant auto account information.',
  P70: 'No open personal installment loans in your credit file.',
  P71: 'One or more of your installment accounts has been paid on time.',
  P72: 'Few or no installment accounts with delinquent or derogatory payment status.',
  P73: 'No installment accounts with a severe delinquency or derogatory status.',
  P74: 'Amount of balance paid down on open installment accounts is not too low.',
  P75: 'Your most recently opened installment account is not too new.',
  P76: 'Your credit file has enough history on your use of installment loans.',
  P77: 'Newest delinquent /derogatory status on installment accounts not too recent.',
  P78: 'Installment account balances not too high compared to loan amounts.',
  P79: 'You have few or no recent delinquencies on your installment accounts.',
  P81: 'No open installment accounts in your credit file.',
  P83: 'Lack of sufficient relevant installment account information.',
  P85: 'You have few or no inquiries on your credit report.',
  P86: 'You have few or no derogatory public records on your credit report.',
  P87: 'You have few or no unsatisfied public records on your credit report.',
  P88: 'You have no recent derogatory public records on your credit report.',
  P90: 'You have one or more discharged bankruptcies.',
  P92: 'No open student loan accounts in your credit file.',
  P93: 'No student loan accounts with a severe delinquency or derogatory status.',
  P94: 'Amount of balance paid down on open student loan accounts is not too low.',
  P95: 'You have few or no unpaid collection agency accounts.',
  P96: 'You have few or no collection agency account balances.',
  P98: 'There is no bankruptcy on your credit report.',
};

export const VANTAGE_SCORE_MAP = {
  '04': 'The balances on your accounts are too high compared to loan limits.',
  '05': 'Too many of the delinquencies on your accounts are recent.',
  '06': 'You have too many accounts that were opened recently.',
  '07': 'You have too many delinquent or derogatory accounts.',
  '08': 'You have either too few loans or too many loans with recent delinquencies.',
  '09': 'The most serious payment status on your accts is delinquent or derogatory.',
  10: 'You have not paid enough of your accounts on time.',
  11: 'The total of your delinquent or derogatory account balances is too high.',
  12: 'The date that you opened your oldest account is too recent.',
  13: 'Your most recently opened account is too new.',
  14: 'Lack of sufficient credit history.',
  15: 'Newest delinquent/derogatory payment status on your accts is too recent.',
  16: 'The total of all balances on your open accounts is too high.',
  17: 'Balance on previously delinquent accts are too high compared to loan amts.',
  18: 'Total of balances on accts never late is too high compared to loan amts.',
  21: 'No open accounts in your credit file.',
  22: 'No recently reported account information.',
  23: 'Lack of sufficient relevant account information.',
  29: 'Too many of your open bank card or revolving accounts have a balance.',
  30: 'Too few of your bank card or other revolving accounts have high limits.',
  31: 'Too many bank card or other revolving accounts were opened recently.',
  32: 'Balances on bankcard/revolving accts too high compared to credit limits.',
  33: 'Your worst bankcard or revolving accounts status is delinquent/derogatory.',
  34: 'Total of all balances on bank card or revolving accounts is too high.',
  35: 'Your highest bankcard or revolving account balance is too high.',
  36: 'Your largest credit limit on open bankcard or revolving accounts is too low.',
  39: 'Available credit on your open bankcard or revolving accounts is too low.',
  40: 'The date you opened your oldest bank card or revolving acct is too recent.',
  42: 'The date you opened your newest bank card or revolving acct is too recent.',
  43: 'Lack of sufficient credit history on bank card or revolving accounts.',
  44: 'Too many bankcard or revolving accounts with delinquent/derogatory status.',
  45: 'Total balances too high on delinquent/derogatory bankcard/revolving accts.',
  46: 'No bankcard, revolving accts that can be used to determine a credit score.',
  47: 'No open bank card or revolving accounts in your credit file.',
  48: 'No bankcard or revolving recently reported account information.',
  49: 'Lack of sufficient relevant bankcard or revolving account information.',
  53: 'The worst status on your real estate accounts is delinquent or derogatory.',
  54: 'The amt of balance paid down on your open real estate accounts is too low.',
  55: 'Open real estate acct balances are too high compared to their loan amts.',
  56: 'Too few real estate accounts.',
  57: 'Too many real estate accts with delinquent or derogatory payment status.',
  58: 'The total of all balances on your open real estate accounts is too high.',
  59: 'Newest delinquent or derogatory status on real estate accts is too recent.',
  61: 'No open real estate accounts in your credit file.',
  62: 'No recently reported real estate account information.',
  63: 'Lack of sufficient relevant real estate account information.',
  66: 'Your open auto account balances are too high compared to their loan amts.',
  67: 'No auto accounts that can be used to determine a credit score.',
  68: 'No open auto accounts in your credit file.',
  69: 'Lack of sufficient relevant auto account information.',
  71: 'You have not paid enough of your installment accounts on time.',
  72: 'Too many installment accts with a delinquent or derogatory payment status.',
  73: 'The worst status on your installment accounts is delinquent or derogatory.',
  74: 'The balance amount paid down on your open installment accounts is too low.',
  75: 'The installment account that you opened most recently is too new.',
  76: 'You have insufficient credit history on installment loans.',
  77: 'Newest delinquent or derogatory status on installment accts is too recent.',
  78: 'Balances on installment accts are too high compared to their loan amounts.',
  79: 'Too many of the delinquencies on your installment accounts are recent.',
  81: 'No open installment accounts in your credit file.',
  82: 'No recently reported installment account information.',
  83: 'Lack of sufficient relevant installment account information.',
  84: 'Number of inquiries impacted your score, but effect was not significant.',
  85: 'You have too many inquiries on your credit report.',
  86: 'Your credit report contains too many derogatory public records.',
  87: 'Your credit report contains too many unsatisfied public records.',
  88: 'One or more derogatory public records in your credit file is too recent.',
  90: 'Too few discharged bankruptcies.',
  93: 'The worst status on your student loan accts is delinquent or derogatory.',
  94: 'The balance amount paid down on your open student loan accts is too low.',
  95: 'You have too many collection agency accounts that are unpaid.',
  96: 'The total you owe on collection agency accounts is high.',
  97: 'You have too few credit accounts.',
  98: 'There is a bankruptcy on your credit report.',
};

/**
 * VantageScore 4.0 negative factor codes.
 * @see https://connectapi.experian.com/api/doc/credit-score.html
 */
export const VANTAGE_SCORE_MAP_V4 = {
  '03': 'Average time since accounts opened is too recent.',
  '04': 'Balances on accts too high compared to credit limits and loan amounts.',
  '05': 'Too many recent delinquencies.',
  '06': 'Too many accounts recently opened.',
  '07': 'Too many delinquent or derogatory accounts.',
  '08': 'Too few accounts recently paid as agreed.',
  '09': 'Delinquent or derogatory account.',
  '10': 'Too few accounts paid as agreed.',
  '11': 'Oldest account was opened too recently.',
  '12': 'Delinquent or derogatory status on accounts is too recent.',
  '13': 'Balances on delinquent or derogatory accounts are too high.',
  '14': 'Too high proportion of accounts recently opened.',
  '15': 'Lack of recently reported accounts.',
  '16': 'Total of credit limits and loan amounts is too low.',
  '17': 'No open accounts in your credit file.',
  '18': 'Lack of account information.',
  '20': 'Delinquent or derogatory bankcard.',
  '21': 'Too many bankcards with a high balance.',
  '22': 'Too few bankcards with high credit limit.',
  '23': 'Too high proportion of bankcards recently opened.',
  '24': 'Too many bankcards with high balance compared to credit limit.',
  '25': 'Too high proportion of balances from bankcards.',
  '26': 'Balances on bankcards are too high.',
  '27': 'Delinquent or derogatory status on revolving accounts is too recent.',
  '28': 'Average credit limit on open bankcards is too low.',
  '29': 'Balances on bankcards are too high compared with credit limits.',
  '30': 'Too few open revolving accounts.',
  '31': 'Not enough available credit on revolving accounts.',
  '32': 'Oldest bankcard was opened too recently.',
  '33': 'Not enough balance paid down over time on bankcards.',
  '34': 'Most recently opened revolving account is too new.',
  '35': 'Lack of revolving account information.',
  '36': 'Lack of recently reported revolving accounts.',
  '37': 'No open bankcards in your credit file.',
  '38': 'Lack of bankcard account information.',
  '39': 'Balances on delinquent or derogatory bankcards are too high.',
  '40': 'Too many delinquent or derogatory revolving accounts.',
  '41': 'Average time since revolving accounts opened is too recent.',
  '42': 'Total credit limits on open revolving accounts are too low.',
  '43': 'Too many revolving accounts with high balance compared to credit limit.',
  '44': 'Balances on revolving accts are too high compared with credit limits.',
  '45': 'Not enough balance paid down over time on retail accounts.',
  '46': 'Oldest revolving account was opened too recently.',
  '47': 'No open retail accounts in your credit file.',
  '48': 'Lack of retail account information.',
  '49': 'Not enough balance paid down over time on revolving accounts.',
  '50': 'Balances on personal installment accts too high compared to loan amts.',
  '51': 'Too few installment accounts recently paid as agreed.',
  '52': 'Delinquent or derogatory installment account.',
  '53': 'Not enough balance paid down over time on installment accounts.',
  '54': 'Delinquent or derogatory status on installment accounts is too recent.',
  '55': 'Lack of recently reported auto accounts.',
  '56': 'Lack of recently reported installment accounts.',
  '57': 'No open installment accounts in your credit file.',
  '58': 'Lack of installment account information.',
  '59': 'Balances on retail cards are too high compared with credit limits.',
  '60': 'Total delinquent or derogatory balances on real estate loans too high.',
  '61': 'No open first mortgage accounts in your credit file.',
  '62': 'Lack of first mortgage account information.',
  '63': 'Delinquent or derogatory real estate secured loan.',
  '64': 'Not enough balance paid down over time on real estate secured loans.',
  '65': 'Oldest real estate secured loan was opened too recently.',
  '66': 'Delinquent or derogatory status on real estate loans is too recent.',
  '67': 'No open real estate secured loans in your credit file.',
  '68': 'Lack of real estate secured loan information.',
  '69': 'Too high proportion of balances from loans not secured by real estate.',
  '70': 'Too high proportion of auto accounts are delinquent or derogatory.',
  '71': 'Not enough balance paid down over time on auto accounts.',
  '72': 'Too few auto accounts paid as agreed.',
  '73': 'Delinquent or derogatory auto account.',
  '74': 'Balances on auto accounts are too high compared with loan amounts.',
  '75': 'Payments on auto accounts less than scheduled amount.',
  '76': 'Delinquent or derogatory status on auto accounts is too recent.',
  '77': 'No open auto accounts in your credit file.',
  '78': 'Lack of auto account information.',
  '80': 'Delinquent or derogatory student loan.',
  '81': 'Not enough balance paid down over time on student loans.',
  '82': 'Lack of recently reported student loans.',
  '84': 'Number of inquiries was a factor in determining the score.',
  '85': 'Too many inquiries.',
  '86': 'Derogatory public records.',
  '87': 'Unpaid collections.',
  '88': 'Bankruptcy.',
  '90': 'No open revolving accounts in your credit file.',
  '91': 'Balances on delinquent or derogatory revolving accts are too high.',
  '92': 'Delinquent or derogatory first mortgage.',
  '93': 'Not enough balance paid down over time on first mortgage accounts.',
  '96': 'Too few open accounts.',
  '97': 'Too few accounts.',
};

/**
 * VantageScore 4.0 positive factor codes.
 * @see https://connectapi.experian.com/api/doc/credit-score.html
 */
export const POSITIVE_VANTAGE_SCORE_MAP_V4 = {
  P03: 'Average time since accounts opened is not too recent.',
  P04: 'Balances on accts are low compared to credit limits and loan amounts.',
  P05: 'Few or no recent delinquencies.',
  P06: 'Few or no accounts recently opened.',
  P07: 'Few or no accounts delinquent or derogatory.',
  P08: 'One or more accounts recently paid as agreed.',
  P09: 'No delinquent or derogatory account.',
  P10: 'One or more accounts paid as agreed.',
  P11: 'Oldest account was not opened too recently.',
  P12: 'Delinquent or derogatory status on accounts is not too recent.',
  P13: 'Balances on delinquent or derogatory accounts are not too high.',
  P14: 'Proportion of accounts recently opened not too high.',
  P15: 'Lack of recently reported accounts.',
  P16: 'Total of credit limits and loan amounts is high.',
  P17: 'No open accounts in your credit file.',
  P18: 'Lack of account information.',
  P19: 'Enough real estate secured loans.',
  P20: 'No delinquent or derogatory bankcard.',
  P21: 'Few or no bankcards with a high balance.',
  P22: 'One or more bankcards with high credit limit.',
  P23: 'Proportion of bankcards recently opened not too high.',
  P24: 'Few or no bankcards with high balance compared to credit limit.',
  P25: 'Proportion of balances from bankcards not too high.',
  P26: 'Balances on bankcards are not too high.',
  P27: 'Delinquent or derogatory status on revolving accts is not too recent.',
  P28: 'Average credit limit on open bankcards is high.',
  P29: 'Balances on bankcards are not too high compared with credit limits.',
  P30: 'Enough open revolving accounts.',
  P31: 'Available credit on open revolving accounts is high.',
  P32: 'Oldest bankcard was not opened too recently.',
  P33: 'Balance paid down over time on bankcards is high.',
  P34: 'Most recently opened revolving account is not too new.',
  P35: 'Lack of revolving account information.',
  P36: 'Lack of recently reported revolving accounts.',
  P37: 'No open bankcards in your credit file.',
  P38: 'Lack of bankcard account information.',
  P39: 'Balances on delinquent or derogatory bankcards are not too high.',
  P40: 'Few or no revolving accounts delinquent or derogatory.',
  P41: 'Average time since revolving accounts opened is not too recent.',
  P42: 'Total credit limits on open revolving accounts are high.',
  P43: 'Few or no revolving accts with high balance compared to credit limit.',
  P44: 'Balances on revolving accts are not too high compared to credit limits.',
  P45: 'Balance paid down over time on retail accounts is high.',
  P46: 'Oldest revolving account was not opened too recently.',
  P47: 'No open retail accounts in your credit file.',
  P48: 'Lack of retail account information.',
  P49: 'Balance paid down over time on revolving accounts is high.',
  P50: 'Balances on personal installment not too high compared to loan amounts.',
  P51: 'One or more installment accounts recently paid as agreed.',
  P52: 'No delinquent or derogatory installment account.',
  P53: 'Balance paid down over time on installment accounts is high.',
  P54: 'Delinquent or derogatory status on installment accts is not too recent.',
  P55: 'Lack of recently reported auto accounts.',
  P56: 'Lack of recently reported installment accounts.',
  P57: 'No open installment accounts in your credit file.',
  P58: 'Lack of installment account information.',
  P59: 'Balances on retail cards are not too high compared with credit limits.',
  P60: 'Delinquent or derogatory balances on real estate loans not too high.',
  P61: 'No open first mortgage accounts in your credit file.',
  P62: 'Lack of first mortgage account information.',
  P63: 'No delinquent or derogatory real estate secured loan.',
  P64: 'Balance paid down over time on real estate secured loans is high.',
  P65: 'Oldest real estate secured loan was not opened too recently.',
  P66: 'Delinquent or derogatory status on real estate loans is not too recent.',
  P68: 'Lack of real estate secured loan information.',
  P69: 'Proportion of balances on loans not secured by real estate is not high.',
  P70: 'Proportion of delinquent or derogatory auto accounts is not too high.',
  P71: 'Balance paid down over time on auto accounts is high.',
  P72: 'One or more auto accounts were paid as agreed.',
  P73: 'No delinquent or derogatory auto account.',
  P74: 'Balances on auto accounts are not too high compared with loan amounts.',
  P75: 'Few or no payments on auto accounts less than scheduled amount.',
  P76: 'Delinquent or derogatory status on auto accounts is not too recent.',
  P77: 'No open auto accounts in your credit file.',
  P78: 'Lack of auto account information.',
  P79: 'Few or no installment or auto accounts recently opened.',
  P80: 'No delinquent or derogatory student loan.',
  P81: 'Balance paid down over time on student loans is high.',
  P82: 'Lack of recently reported student loans.',
  P83: 'Lack of student loan information.',
  P85: 'Few or no inquiries.',
  P86: 'Few or no derogatory public records.',
  P87: 'Few or no unpaid collections.',
  P88: 'No bankruptcy.',
  P89: 'No open student loans in your credit file.',
  P90: 'No open revolving accounts in your credit file.',
  P91: 'Balances on delinquent or derogatory revolving accts are not too high.',
  P92: 'No delinquent or derogatory first mortgage.',
  P93: 'Balance paid down over time on first mortgage accounts is high.',
  P94: 'No delinquent or derogatory revolving account.',
  P95: 'Few or no bankcard or revolving accounts recently opened.',
  P96: 'Enough open credit accounts.',
  P97: 'Enough credit accounts.',
  P98: 'There is no bankruptcy on your credit report.',
};

const DESCRIPTION_UNAVAILABLE = 'Description unavailable.';

/**
 * Returns the human-readable description for a VantageScore factor code.
 * Chooses V3 or V4 message set based on riskModel.ModelIndicator.code.
 */
export function getScoreFactorDescription(
  riskModel: { ModelIndicator?: { code?: string } } | null | undefined,
  scoreFactor: string,
  isPositive: boolean,
): string {
  const isV4 = riskModel?.ModelIndicator?.code === 'V4';
  const scoreMap = isPositive
    ? isV4
      ? POSITIVE_VANTAGE_SCORE_MAP_V4
      : POSITIVE_VANTAGE_SCORE_MAP
    : isV4
      ? VANTAGE_SCORE_MAP_V4
      : VANTAGE_SCORE_MAP;
  const key = isPositive ? scoreFactor : String(scoreFactor);
  const description = (scoreMap as Record<string, string>)[key];
  return description ?? DESCRIPTION_UNAVAILABLE;
}

export const DATA_UNAVAILABLE_TEXT = '-';

// Crazy codes that might be returned by Experian.
export const OLD_ADDRESS_CODE = '         2';
